import html from '../assets/svg/skills/html.svg'
import css from '../assets/svg/skills/css.svg'
import javascript from '../assets/svg/skills/javascript.svg'
import jquery from '../assets/svg/skills/jquery.svg'
import php from '../assets/svg/skills/php.svg'
import vue from '../assets/svg/skills/vue.svg'
import nuxtJS from '../assets/svg/skills/nuxtJS.svg'
import nodeJS from '../assets/svg/skills/nodeJS.svg'
import expressJS from '../assets/svg/skills/expressJS.svg'
import bootstrap from '../assets/svg/skills/bootstrap.svg'
import vuetifyjs from '../assets/svg/skills/vuetifyjs.svg'
import tailwind from '../assets/svg/skills/tailwind.svg'
import git from '../assets/svg/skills/git.svg'
import firebase from '../assets/svg/skills/firebase.svg'
import mysql from '../assets/svg/skills/mysql.svg'
import sqlite from '../assets/svg/skills/sqlite.svg'
import mongoDB from '../assets/svg/skills/mongoDB.svg'
import laravel from '../assets/svg/skills/laravel.svg'
import livewire from '../assets/svg/skills/livewire.svg'
import pinia from '../assets/svg/skills/pinia.svg'
import gitlab from '../assets/svg/skills/gitlab.svg'
import github from '../assets/svg/skills/github.svg'
import jira from '../assets/svg/skills/jira.svg'
import ubuntu from '../assets/svg/skills/ubuntu.svg'
import slack from '../assets/svg/skills/slack.svg'
import socket from '../assets/svg/skills/socket.svg'
import odoo from '../assets/svg/skills/odoo.svg'


export const skillsImage = (skill) => {
    const skillID = skill.toLowerCase();
    switch (skillID) {
        case 'html':
            return html;
        case 'css':
            return css;
        case 'javascript':
            return javascript;
        case 'jquery':
            return jquery;
        case 'php':
            return php;
        case 'vue.js':
        case 'vue':
            return vue;
        case 'nuxt.js':
        case 'nuxt js':
            return nuxtJS;
        case 'node.js':
        case 'node js':
            return nodeJS;
        case 'express.js':
        case 'express js':
            return expressJS;
        case 'bootstrap':
            return bootstrap;
        case 'vuetify':
        case 'vuetifyjs':
            return vuetifyjs;
        case 'tailwind css':
        case 'tailwind':
            return tailwind;
        case 'git':
            return git;
        case 'firebase':
            return firebase;
        case 'mysql':
            return mysql;
        case 'sqlite':
            return sqlite;
        case 'mongodb':
            return mongoDB;
        case 'laravel':
            return laravel;
        case 'livewire':
            return livewire;
        case 'pinia':
            return pinia;
        case 'gitlab':
            return gitlab;
        case 'github':
            return github;
        case 'jira':
            return jira;
        case 'ubuntu':
            return ubuntu;
        case 'slack':
            return slack;
        case 'socket':
            return socket;
        case 'odoo':
            return odoo;
        default:
            return null;
    }
}
